import logo from "../assets/images/logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import {
  useRef,
  useState,
  useLayoutEffect,
  useEffect,
  useContext,
} from "react";
import { DataContext } from "../index";
import SarrafiIex from "../assets/images/PersianLogo.png";

function Header() {
  const navRef = useRef();
  const bgRef = useRef();
  const calcCotext = useContext(DataContext);
  const [page, setPage] = calcCotext.page;

  const handleShowNav = () => {
    bgRef.current.classList.toggle("d-block");
    navRef.current.classList.toggle("d-block");
    document.body.classList.toggle("overflow-hidden");
  };

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth > 1200) {
        bgRef.current.classList.remove("d-block");
        navRef.current.classList.remove("d-block");
        document.body.classList.remove("overflow-hidden");
      }
    }
    window.addEventListener("resize", handleResize);
  });

  const handleCloseNav = () => {
    bgRef.current.classList.remove("d-block");
    navRef.current.classList.remove("d-block");
    document.body.classList.remove("overflow-hidden");
  };
  return (
    <>
      <div
        className="backdrop"
        ref={bgRef}
        onClick={(event) => {
          handleShowNav(event);
        }}
      ></div>
      <header className="top-header">
        <section className="right-part">
          <span className="logo-container">
            <img height={70} src={logo} />
          </span>
          <span className="desc-header">
            <p>شرکت تضامنی اشراقی و شرکا </p>
            <p>با مجوز رسمی از بانک مرکزی جمهوری اسلامی ایران</p>
            <p>شماره ثبت :۵۱۰۲۸۳</p>
          </span>
        </section>

        <section className="HeaderTitle">
          <img src={SarrafiIex}></img>

          {/* <div className='turnMobile' >
      <a target="_blank" rel="noreferrer" href="https://my.ice.ir" >
          نوبت دهی
      </a>
  </div> */}
        </section>

        <section className="left-part">
          <div className="menu-container" ref={navRef}>
            <ul className="menu">
              <li
                className={`${page === 1 ? `selectedItem` : null}`}
                onClick={() => {
                  handleCloseNav();
                  setPage(1);
                }}
              >
                خانه
              </li>

              <li
                className={`${page === 2 ? "selectedItem" : null}`}
                onClick={() => {
                  handleCloseNav();
                  setPage(2);
                }}
              >
                آرشیو
              </li>
              <li
                className={`${page === 3 ? "selectedItem" : null}`}
                onClick={() => {
                  handleCloseNav();
                  setPage(3);
                }}
              >
                درباره ما
              </li>
              <li
                className={`${page === 4 ? "selectedItem" : null}`}
                onClick={() => {
                  handleCloseNav();
                  setPage(4);
                }}
              >
                تماس با ما
              </li>
              <li
                className="mobile-calendar"
                onClick={() => {
                  setPage(1);
                }}
              >
                <img height={60} src={logo} />
              </li>

              {/* <li onClick={() => { handleCloseNav()}}>
            <a target="_blank" rel="noreferrer" href="https://my.ice.ir" style={{textDecoration:'none' , color:'#000', paddingLeft:'7px', paddingRight:'7px', paddingTop:'3px', paddingBottom:'3px',
            fontWeight:'bold',
             backgroundColor:"#ffab1f" ,borderRadius:'10px'}}>
                نوبت دهی
              </a>
              </li> */}
            </ul>
          </div>
          <span
            className="nav-icon"
            onClick={(event) => {
              handleShowNav(event);
            }}
          >
            <FontAwesomeIcon
              icon={faBars}
              size="2x"
              style={{ color: "#ffc732" }}
            />
          </span>
        </section>
      </header>
    </>
  );
}

export default Header;
